// extracted by mini-css-extract-plugin
export default {"wrapper":"PaginationWrapper_wrapper__meNkZ"};